export enum EThemes {
  dark = `dark`,
  light = `light`
}

export interface IStyleProviderState {
  theme: EThemes;
}
